<template>
    <div class="flex flex-col space-y-0.5">
         <ClientFeedbackCell :company="company" @refetch-companies="fetchNewCompanies"/>
         <base-pill> Notes:</base-pill> <ClientMeetingNotesCell :company="company" @refetch-companies="fetchNewCompanies" class="inline" />
         <base-pill>Tier Buttons:</base-pill>
         <MarkTierButtonsCell :company="company" @refetch-companies="fetchNewCompanies" />
    </div>
</template>

<script>
    export default {
        name: "client-feedback-client-meeting-notes-tier-buttons-cell"
    }
</script>

<script setup>
import { defineProps, defineEmits } from 'vue';
import ClientFeedbackCell from '../company-cell-components/ClientFeedbackCell.vue';
import ClientMeetingNotesCell from '../company-cell-components/ClientMeetingNotesCell.vue';
import MarkTierButtonsCell from '../company-cell-components/MarkTierButtonsCell.vue';

    const props = defineProps({
        company: Object
    })

    const emit = defineEmits(['refetch-companies'])

    function fetchNewCompanies(){
        emit('refetch-companies')
    }

</script>